import { Dispatch, SetStateAction, useState } from 'react';

interface UseState {
    expanded: boolean;
    setExpanded: Dispatch<SetStateAction<boolean>>;
    toggleExpanded: () => void;
}

const useExpansion = (): UseState => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const toggleExpanded = () => setExpanded((previous: boolean) => !previous);

    return {
        expanded,
        setExpanded,
        toggleExpanded,
    };
};

export type { UseState as UseExpansionState };
export { useExpansion };
